import { createSelector } from 'reselect';
// eslint-disable-next-line import/no-cycle
import CarrierResdit7421PerformanceLocationData from '../../containers/CarrierResdit7421PerformanceLocationData';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import { getPropertyValueByPath } from "../../../../../../react-table/helpers/utils";
import { getReportState, getReportMode } from "../../../../../common/redux/selectors/ReportsSelectors";
import CarrierResdit7421PerformanceLocationColumns from "../../containers/CarrierResdit7421PerformanceLocationColumns";

export const COLUMN_ACCESSOR_CARDIT_TOTAL = 'cardit.total';

export const HEADER_CARDIT = 'cardit';
export const HEADER_RESDIT = 'resdit';

export const COLUMN_LEAF_EXCLUSIONS = ['cardit.postalOperator'];

export const PROPERTY_ORIGINAL_GRAND_TOTAL = 'originalGrandTotal';
export const PROPERTY_ORIGINAL_GROUP_TOTAL = 'originalGroupTotal';

export const getGeneratedOnDateTime = state => state
  .reporting.RESDIT_74_21_PERFORMANCE_LOCATION_802.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_802.isLoading;

export const getIsFiltered = state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_802.filtering &&
  state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_802.filtering.appliedFilters &&
  state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_802.filtering.appliedFilters.some(filter => !filter.value.clearFilter);

export const getData =
  ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.getDataFunction();

export const getOriginalGrandTotal = state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_802.data
  .map(row => getPropertyValueByPath(row, COLUMN_ACCESSOR_CARDIT_TOTAL)[0])
  .reduce((grandTotal, groupTotal) => grandTotal + groupTotal, 0);

export const getColumns =
  // eslint-disable-next-line max-len
  createSelector(
    getData,
    state => state.reporting.RESDIT_74_21_PERFORMANCE_LOCATION_802.requestParams,
    state => getReportMode(state, ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id),
    CarrierResdit7421PerformanceLocationColumns,
  );

export const getFilteredAndSortedData =
  createSelector(
    state => getReportState(state, ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id),
    getColumns,
    CarrierResdit7421PerformanceLocationData,
  );
